export default __webpack_public_path__ + "static/media/background10.9f9e6b17.jpg";